import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import NewKBRecordCallModal from './NewKBRecordCallModal';
import { useNewKBLeadForm } from '../context/NewKBLeadFormContext';

/**
 * NewKBCallsTab - Call management tab for NewKBLeadModal
 * Directly integrates call functionality within the tab panel
 */
const NewKBCallsTab = () => {
  const { formData, isEditMode } = useNewKBLeadForm();

  /* 
  * We're removing the restriction that required saving the lead first
  * to manage call logs, allowing users to record calls immediately 
  */

  // Pass the lead info directly to the RecordCallModal component
  // and set it to always be open while we're on this tab
  return (
    <Box>
      <NewKBRecordCallModal 
        isOpen={true}
        onClose={() => {}} 
        lead={formData}
        embedded={true} // Tell the component it's embedded in a tab, not a modal
      />
    </Box>
  );
};

export default NewKBCallsTab;
